module.exports = "<div class=\"relative\">\t\n\t<div >\t\t\n\t\t<div ng-bind-html=\"$ctrl.meta | sanitize\" ng-class=\"{'h-300' : $ctrl.expandClose }\"></div>\n\t</div>\n\t<hr>\n\t<div class=\"u-flex u-flexJustifyCenter\">\n\t\t<button class=\"btn-more\" ng-click=\"$ctrl.expandClose = !$ctrl.expandClose\">{{$ctrl.expandClose ? 'Espandi' : 'Chiudi'}} <span class=\"fa\" ng-class=\"[$ctrl.expandClose ? 'fa-plus' : 'fa-minus']\"></span></button>\t\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/expand/expand.html
// module id = 32
// module chunks = 1